import { Util, devLog } from 'utils';
import { HOST } from 'consts/env';
import { FetchManager } from 'services/FetchManager';
import { Language } from 'types/language';
import { create } from 'zustand';

export type LoginFormType = {
  loginId: String;
  password: String;
  activeLanguage: Language;
};

export type AuthStoreType = {
  verifyUserLogin: (formData: LoginFormType) => Promise<any>;
  verifyUserLoginExternal: (loginId: string) => Promise<any>;
  getRoleCollections: () => Promise<any>;
  userLogout: () => Promise<any>;
};

const useAuthAPIStore = create<AuthStoreType>((set) => ({
  async verifyUserLogin(formData: LoginFormType) {
    try {
      const url = `${HOST}/user/login`;
      const res = await FetchManager.post(url, formData);
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog('[verifyUserLogin] 오류 발생', e);
      return false;
    }
  },
  async verifyUserLoginExternal(loginId: string) {
    try {
      const url = `${HOST}/user/external-login`;
      const res = await FetchManager.post(url, { loginId });
      const data = await Util.fetchAndSetData(res);

      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog('[verifyUserLoginExternal] 오류 발생', e);
      return false;
    }
  },
  async getRoleCollections() {
    try {
      const url = `${HOST}/user/role-collections`;
      const res = await FetchManager.get(url);
      const data = await Util.fetchAndSetData(res);
      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog('[getRoleCollections] 오류 발생', e);
      return false;
    }
  },
  async userLogout() {
    try {
      const url = `${HOST}/user/logout`;
      const res = await FetchManager.post(url);
      const data = await Util.fetchAndSetData(res);
      if (data) return data;
      else throw new Error();
    } catch (e) {
      devLog('[userLogout] 오류 발생', e);
      return false;
    }
  },
}));

export default useAuthAPIStore;
